import { toast } from "sonner";
import { Copy } from "lucide-react";
import { EMAIL_TEMPLATES, LINKEDIN_POSTS } from "@/content/emailTemplates";

export default function TemplatesTab() {
  const copyText = async (title, text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(`"${title}" copied`);
    } catch {
      toast.error("Copy failed - select the text manually");
    }
  };

  return (
    <div data-testid="templates-tab" className="max-w-3xl space-y-6">
      <p className="text-sm text-navy/60 leading-relaxed">
        Ready-to-send client and partner emails. Fill the [bracketed] bits, then send from your own inbox.
      </p>
      {EMAIL_TEMPLATES.map((t) => (
        <article key={t.id} data-testid={`template-${t.id}`} className="rounded-2xl bg-white border border-border p-7">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="text-lg font-bold text-navy">{t.title}</h3>
              <p className="mt-1 text-xs text-navy/50 leading-relaxed">{t.note}</p>
            </div>
            <button
              data-testid={`template-copy-${t.id}`}
              onClick={() => copyText(t.title, `Subject: ${t.subject}\n\n${t.body}`)}
              className="shrink-0 inline-flex items-center gap-2 rounded-full border-2 border-navy px-4 py-2 text-xs font-bold text-navy hover:bg-navy hover:text-white transition-colors"
            >
              <Copy className="w-3.5 h-3.5" aria-hidden="true" /> Copy
            </button>
          </div>
          <div className="mt-5 rounded-xl bg-background border border-border p-5">
            <p className="text-sm font-bold text-navy">Subject: {t.subject}</p>
            <pre className="mt-3 whitespace-pre-wrap font-sans text-sm text-navy/75 leading-relaxed">{t.body}</pre>
          </div>
        </article>
      ))}

      <h2 className="pt-6 text-2xl font-bold tracking-tight text-navy">LinkedIn posts (from your articles)</h2>
      <p className="text-sm text-navy/60 leading-relaxed">
        Per the organic plan: 2 posts a week, end every post with the checklist link. Replace [checklist link] with
        https://claruspartners.com.au/xero-health-check before posting.
      </p>
      {LINKEDIN_POSTS.map((p) => (
        <article key={p.id} data-testid={`linkedin-${p.id}`} className="rounded-2xl bg-white border border-border p-7">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="text-lg font-bold text-navy">{p.title}</h3>
              <p className="mt-1 text-xs text-navy/50 leading-relaxed">{p.note}</p>
            </div>
            <button
              data-testid={`linkedin-copy-${p.id}`}
              onClick={() => copyText(p.title, p.body)}
              className="shrink-0 inline-flex items-center gap-2 rounded-full border-2 border-navy px-4 py-2 text-xs font-bold text-navy hover:bg-navy hover:text-white transition-colors"
            >
              <Copy className="w-3.5 h-3.5" aria-hidden="true" /> Copy
            </button>
          </div>
          <div className="mt-5 rounded-xl bg-background border border-border p-5">
            <pre className="whitespace-pre-wrap font-sans text-sm text-navy/75 leading-relaxed">{p.body}</pre>
          </div>
        </article>
      ))}
    </div>
  );
}
